export const directPayment = {
  SEARCH_DEBOUNCE_MS: 300,
  SEARCH_MIN_CHARS: 3,
  MAX_SEARCH_RESULTS: 5,
  SEARCH_PAGE_LIMIT: "20",
  ASSET_ISSUER_PREVIEW_LENGTH: 8,
  RECEIVER_ID_PREVIEW_LENGTH: 8,
} as const;
